import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '@core/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private userService: UserService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    // Try to get allowRoles from current route data
    let allowed: string[] | undefined = route.data['allowRoles'] as string[];

    // If not found in current route, try to get from the first child route
    if (!allowed && route.firstChild) {
      allowed = this.getChildRouteData(route.firstChild);
    }

    // If no roles specified, allow access
    if (!allowed || allowed.length === 0) {
      return true;
    }

    // Ensure user signal is populated — on a hard page-load the APP_INITIALIZER
    // may not have completed before this guard runs, so fall back to localStorage.
    if (!this.userService.user()) {
      const stored = localStorage.getItem('user_info');
      if (stored) {
        try {
          this.userService.setUserInfo(JSON.parse(stored));
        } catch {}
      }
    }

    const hasAccess = this.userService.canAccess(allowed);
    return hasAccess ? true : this.router.parseUrl('/permission-denied');
  }

  private getChildRouteData(route: ActivatedRouteSnapshot): string[] | undefined {
    // Check current route's data
    if (route.data['allowRoles']) {
      return route.data['allowRoles'] as string[];
    }

    // Recursively check children
    if (route.firstChild) {
      return this.getChildRouteData(route.firstChild);
    }

    return undefined;
  }
}
